<template>
  <div v-if="(apiCount>0)" class="loading" id="loading">
    <img src="../../assets/loading.gif" class="loading_img"/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      apiCount: 0,
    };
  },

  created() {
    window.addEventListener('startLoading', (event) => {
      if (this.apiCount < 0) {
        this.apiCount = 0;
      }
      this.apiCount += 1;
    });
    window.addEventListener('endLoading', (event) => {
      if (this.apiCount > 0) {
        this.apiCount -= 1;
      }
    });
  }
};
</script>

<style>
.loading {
  position:fixed;
  width: 100%;
  height: 100%;
  top:0px;
  left:0px;
  z-index: 999;
  background-color: #f8f8f880;
}
.loading .loading_img {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
